const SETTLE_RE = /\bsettle\b(?!ment)|undurluguu|өндөрлөг/i;
const UBCTS_RE = /убцтс|убтцс|ub\s*cts|ubcts|цтс/i;

const expenseText = (row) =>
  [
    row.description,
    row.relatedAccount,
    row.accountingType,
    row.settlementPartnerName,
    ...(Array.isArray(row.customers) ? row.customers.map((c) => c.name) : []),
  ]
    .filter(Boolean)
    .join(" ");

/** Зарлага: зөвхөн Settle | УБЦТС. Орлогонд огт хэрэглэхгүй. */
export function expenseTypeLabel(row) {
  if (row.linkType === "SETTLE" || row.transactionBucketId) return "Settle";
  const text = expenseText(row);
  if (SETTLE_RE.test(text)) return "Settle";
  if (row.accountingType === "УБЦТС" || UBCTS_RE.test(text)) return "УБЦТС";
  return "";
}

/** Орлого: Дан/Багц. Зарлага: Settle/УБЦТС. */
export function btlTypeLabel(row) {
  const amount = parseFloat(row.amount);
  if (Number.isFinite(amount) && amount < 0) return expenseTypeLabel(row);
  if (row.isPack == null) return "";
  return row.isPack ? "Багц" : "Дан";
}

export function rowMerchantMeta(row) {
  const q = row?.qpay;
  const s = row?.settle;
  if (q && (q.merchantId != null || q.merchantName)) {
    return {
      merchantId: q.merchantId != null ? Number(q.merchantId) : null,
      merchantName: q.merchantName ? String(q.merchantName).trim() : null,
    };
  }
  if (s && (s.merchantId != null || s.merchantName)) {
    return {
      merchantId: s.merchantId != null ? Number(s.merchantId) : null,
      merchantName: s.merchantName ? String(s.merchantName).trim() : null,
    };
  }
  return { merchantId: null, merchantName: null };
}
